module.exports = __webpack_public_path__ + "static/img/icon-number-1.720d7e8e.svg";